const MinisterLinks = () => {
  return null
}

export default MinisterLinks
